"use client";

import React from "react";
import { useSelector } from "react-redux";

import { RenewalPage } from "@/config/app-constant";
import { RootState } from "@/store/root-reducer";

import AMTPaymentSelector from "./amt-payment-selector";

type PclSectionProps = {
  priceResultsTitle: string;
  monthlyPaySummaryTitle: string;
  priceSummaryDescription: string;
  policyPriceRow: string;
  totalCreditChargeRow: string;
  intrestRow: string;
  fixedInterestRateLabel: string;
  initialPaymentRow: string;
  installmentsRow: string;
  totalPriceRow: string;
  notAvailableText: string;
  isdesktop?: string;
  interestRowMobile?: string;
};

function AMTPaymentSelectorWrapper({
  priceResultsTitle = "",
  monthlyPaySummaryTitle = "",
  priceSummaryDescription = "",
  policyPriceRow = "",
  totalCreditChargeRow = "",
  intrestRow = "",
  fixedInterestRateLabel = "",
  initialPaymentRow = "",
  installmentsRow = "",
  totalPriceRow = "",
  notAvailableText = "",
  interestRowMobile = undefined,
  isdesktop = "true",
}: Readonly<PclSectionProps>) {
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { paymentDetails } = attributes;

  let pclData = null;
  let fullPayment = "0.00";

  if (paymentDetails) {
    const { paymentOptions } = paymentDetails;
    const [
      {
        cardPayment: {
          premiumCreditPayment: [{ pcl }],
          card: { price },
        },
      },
    ] = paymentOptions;
    pclData = pcl;
    fullPayment = price;
  }

  const summaryTableData = [
    { key: "totalCost", title: policyPriceRow },
    { key: "costOfCredit", title: totalCreditChargeRow },
    {
      key: "annualPercentageRate",
      title:
        isdesktop === "false" ? interestRowMobile ?? intrestRow : intrestRow,
    },
    { key: "fixedInterestRate", title: fixedInterestRateLabel },
    { key: "collectionAmount", title: installmentsRow },
    { key: "depositAmount", title: initialPaymentRow },
  ];

  return (
    <div>
      <AMTPaymentSelector
        priceResultsTitle={priceResultsTitle}
        monthlyPaySummaryTitle={monthlyPaySummaryTitle}
        priceSummaryDescription={priceSummaryDescription}
        pclData={pclData}
        summarayData={summaryTableData}
        totalPriceRow={totalPriceRow}
        fullPayAmount={fullPayment}
        notAvailableText={notAvailableText}
        application={RenewalPage}
      />
    </div>
  );
}

export default AMTPaymentSelectorWrapper;
